module.exports = __webpack_public_path__ + "img/5.4dc059ff.png";